@if (dialogTitle()) {
  <h2 class="dialog-title">
    {{ dialogTitle() }}
  </h2>
}

<ng-content></ng-content>

<button
  (click)="onDismissClick()"
  class="dismiss-btn"
  dataTest="btn-dialog-dismiss"
  [class.rotate-animation]="closeIcon() === CLOSE_ICON"
>
  <outlaw-icon [name]="closeIcon()" size="20px"></outlaw-icon>
</button>
